<template>
	<div>
		<div class="bgHeight" :style="{ width: getIsCollapseStatus?'64px':''}"></div>
		<div class="leftTitleList" :style="{ width: getIsCollapseStatus?'64px':''}">
			<div class="logoImg flex_start" v-show="!getIsCollapseStatus">
				<img class="logoPng" src="../assets/logo.png" alt="" />
				<img class="logoIcon" src="../assets/logoTxt.png" alt="" />
			</div>
			<div class="logoImgs flex_center" v-show="getIsCollapseStatus">
				<img class="logoPng" src="../assets/logo.png" alt="" />
			</div>
			<!-- <div class="homeNav flex_start" @click="gohome" :class="{activeHome:activeId=='-1'}">
				<div class="navIcon" style="margin-top: -12px;"><img src="../assets/icon/home.png" alt=""></div>
				<div class="homeNavText">首页</div>
			</div> -->
			<div class="sideNavList">
				<el-menu :default-active="activeId" :unique-opened="true" class="el-menu-vertical-demo" @open="handleOpen"
					@close="handleClose" background-color="#ffffff" text-color="#333333" active-text-color="#007FFF"
					@select="handleSelect" :collapse="getIsCollapseStatus" :collapse-transition="false">
					<div v-for="(item,index) in navList" :key="index">
						<el-menu-item :index="item.id+''" v-if="!item.children||item.children.length<=0"
							@click="personalData(item,index)">
							<div class="menuTit flex_start">
								<div class="navIcon" v-if="activeId==item.id"><img :src="BASE_URL + item.meta.checkIcon" alt=""></div>
								<div class="navIcon" v-else><img :src="BASE_URL + item.meta.icon" alt=""></div>
								<div class="sideNavTitle" v-show="!getIsCollapseStatus">{{item.meta.title}}</div>
							</div>
						</el-menu-item>
						<el-submenu :index="item.id+''" v-else>
							<template slot="title">
								<div class="menuTit flex_start">
									<div class="navIcon" v-if="isChildOf(item.id,activeId)"><img :src="BASE_URL + item.meta.checkIcon"
											alt=""></div>
									<div class="navIcon" v-else><img :src="BASE_URL + item.meta.icon" alt=""></div>
									<div class="sideNavTitle" v-show="!getIsCollapseStatus">{{item.meta.title}}</div>
								</div>
							</template>
							<el-menu-item-group v-for="(warp,i) in item.children" :key="i">
								<el-menu-item :index="warp.id+''" @click="personalData(warp)">
									<div class="subMenu">{{warp.meta.title}}</div>
								</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
					</div>
				</el-menu>
			</div>
			<!-- <div class="tablist" v-for="(item,index) in titleList" :key="index">
				<div class="leftTitle">{{item.title}}</div>
				<div class="subTitleList">
					<div class="subTitle flex_start" :class="{active:activeId==i.id}" v-for="(i,warp) in item.list" :key="warp"
					@click="check(i)">
						<div class="subTitleicon"></div>
						<div class="subTitleText" :class="{active:activeId==i.id}">{{i.title}}</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// isCollapse: true,
				activeId: '1',
				tabList: [{
						id: '1',
						name: '首页',
						url: '../assets/icon/home.png',
						urls: '../assets/icon/homeChecked.png',
						path: '/home/home'
					},
					{
						id: '2',
						name: '公司管理',
						url: '../assets/icon/company.png',
						urls: '../assets/icon/companyChecked.png',
						path: '/companyManage/companyManage'
					},
					{
						id: '3',
						name: '聚合管理',
						url: '../assets/icon/aggregation.png',
						urls: '../assets/icon/aggregationChecked.png',
						list: [{
								name: '广告网络',
								path: '/aggregation/ADNetwork',
								id: '31'
							},
							{
								name: '应用管理',
								path: '/aggregation/applicationManage',
								id: '32'
							},
							{
								name: '广告位管理',
								path: '/aggregation/adSpaceManage',
								id: '33'
							},
						]
					},
					{
						id: '4',
						name: '数据报表',
						url: '../assets/icon/dataReport.png',
						urls: '../assets/icon/dataReportChecked.png',
						list: [{
								name: '综合报表',
								path: '/dataReport/comprehensiveReport',
								id: '41'
							},
							{
								name: '媒体数据',
								path: '/dataReport/mediaData',
								id: '42'
							},
							{
								name: '分时报表',
								path: '/dataReport/timeShareReport',
								id: '43'
							},
							{
								name: '渠道数据',
								path: '/dataReport/channelData',
								id: '44'
							},
							{
								name: '媒体收入',
								path: '/dataReport/mediaIncome',
								id: '45'
							},
							{
								name: '版本统计',
								path: '/dataReport/versionStatistics',
								id: '46'
							},
						]
					},
					{
						id: '5',
						name: '接入中心',
						url: '../assets/icon/accessCenter.png',
						urls: '../assets/icon/accessCenterChecked.png',
						list: [{
							name: 'SDK集成',
							path: '/accessCenter/SDKIntegration',
							id: '51'
						}]
					},
					{
						id: '6',
						name: '财务结算',
						url: '../assets/icon/finance.png',
						urls: '../assets/icon/financeChecked.png',
						list: [{
								name: '媒体对账单',
								path: '/financeAccount/mediaAccount',
								id: '61'
							},
							{
								name: '对账打款',
								path: '/financeAccount/recordPayment',
								id: '62'
							},
						]
					},
					{
						id: '7',
						name: '审批待办',
						url: '../assets/icon/approvalPending.png',
						urls: '../assets/icon/approvalPendingChecked.png',
						list: [{
								name: '账号注册',
								path: '/approvalPending/accountRegist',
								id: '71'
							},
							{
								name: '公司资质',
								path: '/approvalPending/comanyQuality',
								id: '72'
							},
							{
								name: '应用资质',
								path: '/approvalPending/applicationQuality',
								id: '73'
							},
						]
					},
					{
						id: '8',
						name: '账户管理',
						url: '../assets/icon/accountManage.png',
						urls: '../assets/icon/accountManageChecked.png',
						list: [{
								name: '用户管理',
								path: '/accountManage/userManage',
								id: '81'
							},
							{
								name: '角色管理',
								path: '/accountManage/roleManage',
								id: '82'
							},
						]
					},
					// {
					// 	id: '2',
					// 	name: '媒体管理',
					// 	url: require('../assets/icon/media.png'),
					// 	urls: require('../assets/icon/mediaChecked.png'),
					// 	path: '/mediaManage/mediaManage'
					// },
					// {
					// 	id: '3',
					// 	name: '广告位管理',
					// 	url: require('../assets/icon/ad.png'),
					// 	urls: require('../assets/icon/adChecked.png'),
					// 	path: 'adSpaceManage'
					// },
					// {
					// 	name: '数据管理',
					// 	url: require('../assets/icon/data.png'),
					// 	urls: require('../assets/icon/dataChecked.png'),
					// 	id: '4',
					// 	list: [{
					// 			name: '应用数据',
					// 			path: '/dataManage/appData',
					// 			id: '41'
					// 		},{
					// 			name: '媒体数据',
					// 			path: '/dataManage/dataShow',
					// 			id: '42'
					// 		},
					// 		{
					// 			name: '渠道数据',
					// 			path: '/dataManage/channelIncome',
					// 			id: '43'
					// 		},
					// 		{
					// 			name: '媒体收入',
					// 			path: '/dataManage/mediaIncome',
					// 			id: '44'
					// 		},
					// 	]
					// },
					// {
					// 	name: '财务对账',
					// 	url: require('../assets/icon/finance.png'),
					// 	urls: require('../assets/icon/financeChecked.png'),
					// 	id: '5',
					// 	list: [{
					// 			name: '媒体对账单',
					// 			path: '/mediaAccount',
					// 			id: '51'
					// 		},
					// 		{
					// 			name: '对账打款',
					// 			path: '/recordPayment',
					// 			id: '52'
					// 		},
					// 	]
					// },
					// {
					// 	id: '6',
					// 	name: 'SDK版本管理',
					// 	url: require('../assets/icon/SDKVersion.png'),
					// 	urls: require('../assets/icon/SDKVersionChecked.png'),
					// 	path: 'SDKVersion'
					// },
					// {
					// 	id: '7',
					// 	name: '账户管理',
					// 	url: require('../assets/icon/users.png'),
					// 	urls: require('../assets/icon/usersCheck.png'),
					// 	list: [{
					// 			name: '用户管理',
					// 			path: '/userManage',
					// 			id: '71'
					// 		},
					// 		{
					// 			name: '角色管理',
					// 			path: '/roleManage',
					// 			id: '72'
					// 		},
					// 	]
					// },
				],
				// arrs : [
				// 	{title: '公司管理',path: '/companyManage/companyManage'},
				// 	{title: '媒体管理',path: '/mediaManage/mediaManage'},
				// 	{title: '广告位管理',path: '/adSpaceManage/adSpaceManage'},
				// 	{title: '应用数据',path: '/dataManage/appData'},
				// 	{title: '媒体数据',path: '/dataManage/dataShow'},
				// 	{title: '渠道数据',path: '/dataManage/channelIncome'},
				// 	{title: '媒体收入',path: '/dataManage/mediaIncome'},
				// 	{title: '媒体对账单',path: '/financeAccount/mediaAccount'},
				// 	{title: '对账打款',path: '/financeAccount/recordPayment'},
				// 	{title: 'SDK版本管理',path: '/SDKVersion/SDKVersion'},
				// 	{title: '用户管理',path: '/userManage/userManage'},
				// 	{title: '角色管理',path: '/userManage/roleManage'},
				// ],
				// arr2: [
				// 	{title: '公司管理',icon:'/icon/company.png',icon_check:'/icon/companyChecked.png'},
				// 	{title: '媒体管理',icon:'/icon/media.png',icon_check:'/icon/mediaChecked.png'},
				// 	{title: '广告位管理',icon:'/icon/ad.png',icon_check:'/icon/adChecked.png'},
				// 	{title: '数据管理',icon:'/icon/data.png',icon_check:'/icon/dataChecked.png'},
				// 	{title: '财务对账',icon:'/icon/finance.png',icon_check:'/icon/financeChecked.png'},
				// 	{title: 'SDK版本管理',icon:'/icon/SDKVersion.png',icon_check:'/icon/SDKVersionChecked.png'},
				// 	{title: '账户管理',icon:'/icon/users.png',icon_check:'/icon/usersCheck.png'},
				// ],
				// auth:[
				// 	{title:'首页',btn:'查询',dict:'home:home:query'},
				// 	{title:'公司管理',btn:'查询',dict:'company:company:query'},
				// 	{title:'公司管理',btn:'新增',dict:'company:company:add'},
				// 	{title:'公司管理',btn:'编辑',dict:'company:company:edit'},
				// 	{title:'公司管理',btn:'媒体管理',dict:'company:company:mediaManage'},
				// 	{title:'广告网络',btn:'查询',dict:'aggregation:ADNetwork:query'},
				// 	{title:'广告网络',btn:'新增',dict:'aggregation:ADNetwork:add'},
				// 	{title:'广告网络',btn:'编辑',dict:'aggregation:ADNetwork:edit'},
				// 	{title:'广告网络',btn:'导出',dict:'aggregation:ADNetwork:export'},
				// 	{title:'应用管理',btn:'查询',dict:'aggregation:applicationManage:query'},
				// 	{title:'应用管理',btn:'新增',dict:'aggregation:applicationManage:add'},
				// 	{title:'应用管理',btn:'详情',dict:'aggregation:applicationManage:info'},
				// 	{title:'应用管理',btn:'关联渠道',dict:'aggregation:applicationManage:association'},
				// 	{title:'广告位管理',btn:'查询',dict:'aggregation:adSpaceManage:query'},
				// 	{title:'广告位管理',btn:'新增',dict:'aggregation:adSpaceManage:add'},
				// 	{title:'广告位管理',btn:'编辑',dict:'aggregation:adSpaceManage:edit'},
				// 	{title:'广告位管理',btn:'配置',dict:'aggregation:adSpaceManage:config'},
				// 	{title:'综合报表',btn:'查询',dict:'dataReport:comprehensiveReport:query'},
				// 	{title:'综合报表',btn:'导出',dict:'dataReport:comprehensiveReport:export'},
				// 	{title:'媒体数据',btn:'查询',dict:'dataReport:mediaData:query'},
				// 	{title:'媒体数据',btn:'导出',dict:'dataReport:mediaData:export'},
				// 	{title:'媒体数据',btn:'分时',dict:'dataReport:mediaData:timeshare'},
				// 	{title:'渠道数据',btn:'查询',dict:'dataReport:channelData:query'},
				// 	{title:'渠道数据',btn:'导出',dict:'dataReport:channelData:export'},
				// 	{title:'媒体收入',btn:'查询',dict:'dataReport:mediaIncome:query'},
				// 	{title:'媒体收入',btn:'导出',dict:'dataReport:mediaIncome:export'},
				// 	{title:'媒体收入',btn:'导入',dict:'dataReport:mediaIncome:import'},
				// 	{title:'媒体收入',btn:'编辑',dict:'dataReport:mediaIncome:edit'},
				// 	{title:'媒体收入',btn:'同步',dict:'dataReport:mediaIncome:async'},
				// 	{title:'版本统计',btn:'查询',dict:'dataReport:versionStatistics:query'},
				// 	{title:'接入中心',btn:'查询',dict:'accessCenter:SDKIntegration:query'},
				// 	{title:'接入中心',btn:'下载',dict:'accessCenter:SDKIntegration:download'},
				// 	{title:'媒体对账单',btn:'查询',dict:'financeAccount:mediaAccount:query'},
				// 	{title:'媒体对账单',btn:'查看',dict:'financeAccount:mediaAccount:download'},
				// 	{title:'媒体对账单',btn:'计算',dict:'financeAccount:mediaAccount:count'},
				// 	{title:'媒体对账单',btn:'生成结算单',dict:'financeAccount:mediaAccount:creatAccount'},
				// 	{title:'媒体对账单',btn:'同步',dict:'financeAccount:mediaAccount:async'},
				// 	{title:'对账打款',btn:'查询',dict:'financeAccount:recordPayment:query'},
				// 	{title:'对账打款',btn:'查看',dict:'financeAccount:recordPayment:download'},
				// 	{title:'对账打款',btn:'核对',dict:'financeAccount:recordPayment:check'},
				// 	{title:'对账打款',btn:'打款',dict:'financeAccount:recordPayment:payment'},
				// 	{title:'公司资质',btn:'查询',dict:'approvalPending:comanyQuality:query'},
				// 	{title:'公司资质',btn:'审核',dict:'approvalPending:comanyQuality:approval'},
				// 	{title:'应用资质',btn:'查询',dict:'approvalPending:applicationQuality:query'},
				// 	{title:'应用资质',btn:'审核',dict:'approvalPending:applicationQuality:approval'},
				// 	{title:'用户管理',btn:'查询',dict:'accountManage:userManage:query'},
				// 	{title:'用户管理',btn:'新增',dict:'accountManage:userManage:add'},
				// 	{title:'用户管理',btn:'编辑',dict:'accountManage:userManage:edit'},
				// 	{title:'用户管理',btn:'删除',dict:'accountManage:userManage:delete'},
				// 	{title:'角色管理',btn:'查询',dict:'accountManage:roleManage:query'},
				// 	{title:'角色管理',btn:'新增',dict:'accountManage:roleManage:add'},
				// 	{title:'角色管理',btn:'编辑',dict:'accountManage:roleManage:edit'},
				// 	{title:'角色管理',btn:'删除',dict:'accountManage:roleManage:delete'},
				// 	{title:'角色管理',btn:'保存',dict:'accountManage:roleManage:save'},
				// ],
				token: '',
				sideKeyIndex: 1,
				arrSec: [{
						name: '广告网络',
						path: '/aggregation/ADNetwork',
						id: '31'
					},
					{
						name: '应用管理',
						path: '/aggregation/applicationManage',
						id: '32'
					},
					{
						name: '广告位管理',
						path: '/aggregation/adSpaceManage',
						id: '33'
					},
					{
						name: '综合报表',
						path: '/dataReport/comprehensiveReport',
						id: '41'
					},
					{
						name: '媒体数据',
						path: '/dataReport/mediaData',
						id: '42'
					},
					{
						name: '渠道数据',
						path: '/dataReport/channelData',
						id: '43'
					},
					{
						name: '媒体收入',
						path: '/dataReport/mediaIncome',
						id: '44'
					},
					{
						name: '版本统计',
						path: '/dataReport/versionStatistics',
						id: '45'
					},
					{
						name: 'SDK集成',
						path: '/accessCenter/SDKIntegration',
						id: '51'
					},
					{
						name: '媒体对账单',
						path: '/financeAccount/mediaAccount',
						id: '61'
					},
					{
						name: '对账打款',
						path: '/financeAccount/recordPayment',
						id: '62'
					},
					{
						name: '账号注册',
						path: '/approvalPending/accountRegist',
						id: '71'
					},
					{
						name: '公司资质',
						path: '/approvalPending/comanyQuality',
						id: '72'
					},
					{
						name: '应用资质',
						path: '/approvalPending/applicationQuality',
						id: '73'
					},
					{
						name: '用户管理',
						path: '/accountManage/userManage',
						id: '81'
					},
					{
						name: '角色管理',
						path: '/accountManage/roleManage',
						id: '82'
					},
				]
			}
		},
		methods: {
			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleSelect(key, keyPath) {
				// console.log(key, keyPath);
				// if(keyPath[0]==4||keyPath[0]==5){
				// 	if(keyPath.length > 1){
				// 		this.sideKeyIndex = keyPath[0]
				// 	}
				// }else{
				// 	this.sideKeyIndex = keyPath[0]
				// }
				// this.sideKeyIndex = key.slice(0,1);
			},
			isChildOf(parentId, childId) {
				// console.log(parentId, childId);
				const parent = this.navList.find(item => item.id == parentId)
				return !!(parent && parent.children && parent.children.find(child => child.id == childId))
			},
			//侧导航点击事件
			personalData(item, index = null) {
				// if (!this.getToken) {
				// 	this.$login()
				// 	return
				// }
				console.log(item);
				this.$router.push({
					path: item.path,
					query: {
						sideId: item.id
					}
				})
				this.activeId = item.id + ''
				let obj = {}
				obj['path'] = item.path
				obj['id'] = item.id
				obj['title'] = item.meta.title
				this.$store.commit('addVisitedViews', obj);
			},
			gohome() {
				this.activeId = '-1'
				this.$router.push({
					path: '/'
				})
			},
			//获取导航列表数据
			getNavList() {
				let data = {
					type: 'nav'
				}
				this.$http.post(this.$api.navList, data).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.tabList = res.data
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			},
		},
		watch: {
			$route() {
				if (this.$route.query.sideId) {
					this.activeId = this.$route.query.sideId + ''
					// this.sideKeyIndex = this.$route.query.sideId.slice(0,1);
				}
			},
		},
		computed: {
			navList() {
				return this.$store.state.navList
			},
			getIsCollapseStatus() {
				return this.$store.getters.getIsCollapseStatus
			}
		},
		mounted() {
			// console.log(JSON.stringify(this.tabList))
			// console.log(JSON.stringify(this.auth))
			this.token = sessionStorage.getItem("token-sdk-system");
			if (!this.token) {
				return false
			}
			if (this.$route.query.sideId) {
				this.activeId = this.$route.query.sideId + ''
				// this.sideKeyIndex = this.$route.query.sideId.slice(0,1);
			} else {
				if (this.navList && this.navList.length > 0) {
					this.activeId = this.navList[0].id + ''
				}
			}
			// console.log(this.navList)
			// this.getNavList();
		},
	}
</script>

<style scoped>
	.bgHeight {
		/* height: calc(100vh - 70px); */
		height: 100vh;
		width: 202px;
	}

	.leftTitleList {
		width: 202px;
		/* height: calc(100vh - 70px); */
		height: 100vh;
		/* border-radius: 10px; */
		background: #FFFFFF;
		/* box-shadow: -2px 0px 20px 0px rgba(34, 28, 30, 0.08); */
		box-shadow: 4px 0px 6px 0px rgba(170, 170, 170, 0.1);
		text-align: center;
		/* padding-top: 22px; */
		position: fixed;
		left: 0;
		top: 0;
		z-index: 11;
		overflow: hidden;
		transition: width 0.28s;
	}

	.logoImg,
	.logoImgs {
		width: 100%;
		height: 76px;
		align-items: center;
		padding-left: 16px;
		box-sizing: border-box;
	}

	.logoImgs {
		padding: 0;
	}

	.logoPng {
		width: 40px;
		height: 40px;
	}

	.logoIcon {
		width: 126px;
		height: 20px;
		margin-left: 4px;
	}

	.tablist {
		margin-top: 15px;
	}

	.leftTitle {
		width: 100%;
		height: 40px;
		line-height: 40px;
		/* background-color: rgba(238,238,238,.6); */
		font-size: 16px;
	}

	.subTitleList {
		/* padding: 10px 0; */
	}

	.subTitle {
		align-items: center;
	}

	.subTitleText {
		line-height: 40px;
		cursor: pointer;
		color: #666666;
		font-size: 14px;
		margin-left: 7px;
	}

	.subTitleicon {
		width: 8px;
		height: 8px;
		background: #36BDDB;
		border-radius: 50%;
		margin-left: 76px;
	}

	.subTitle:hover .subTitleText {
		color: #36BDDB;
	}

	.rightContent {
		width: 1494px;
		/* height: 1254px; */
		margin-bottom: 100px;
	}

	.active {
		/* background-color: rgba(238,238,238,.6); */
		color: #36BDDB;
	}

	.sideNavTitle {
		margin-left: 10px;
	}

	.homeNavText {
		margin-left: 20px;
	}

	.sideNavList {
		width: 100%;
		height: calc(100vh - 76px);
		box-sizing: border-box;
		overflow-y: auto;
		overflow-x: hidden;
		scrollbar-gutter: stable;  /* 现代浏览器适用 */
		/* transition: width 0.28s; */
	}
	/* WebKit浏览器全局样式 */
	.sideNavList::-webkit-scrollbar {
	  width: 2px;
	  /* height: 2px; */
	}
	
	.sideNavList::-webkit-scrollbar-track {
	  background: #e6e6e6;
	  border-radius: 6px;
	}
	.el-menu-vertical-demo{
		box-sizing: border-box;
		max-width: 100%;
	}

	.explainText {
		padding: 0 40px;
		font-size: 12px;
		font-weight: 700;
		color: #c8c8c8;
		width: 250px;
		height: 41px;
		line-height: 41px;
		box-sizing: border-box;
		text-align: left;
	}

	.homeNav {
		width: 250px;
		height: 50px;
		/* border-bottom: 1px solid #EBEEF5 !important; */
		line-height: 50px;
		padding: 0 40px;
		box-sizing: border-box;
		font-size: 14px;
		color: #303133;
		cursor: pointer;
		text-align: left;
		align-items: center;
	}

	.homeNav:hover {
		background-color: whitesmoke;
	}

	.menuTit {
		/* height: 100%;
		align-items: center; */
	}

	.navIcon {
		width: 16px;
		height: 16px;
		margin-top: -1px;
	}

	/*滚动条样式*/
	.side_border::-webkit-scrollbar {
		width: 1px;
	}

	.side_border::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}

	.side_border::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}



	/* 三级菜单的小红点 */
	.dot_dot {
		height: 15px;
		border-radius: 10px;
		color: #fff;
		font-size: 12px;
		text-align: center;
		white-space: nowrap;
		background-color: #F56C6C;
		display: inline-block;
		padding: 0 6px;
		position: relative;
		top: 10px;
		margin-left: 6px;

	}

	/* 三级菜单字体的样式 */
	.chilren_dot {
		position: relative;
		top: -17px;
		color: #fff !important;
	}

	.activeHome {
		color: #4568dc;
		background: #f5f5f5;
	}

	.subMenu {
		text-align: left;
	}

	/deep/ .el-menu {
		border-right: none;
	}
	/deep/ .el-menu-item {
		padding-left: 24px !important;
		height: 48px !important;
		line-height: 48px !important;
	}

	/deep/ .el-menu-item:hover {
		background: rgba(79, 122, 253, 0.1) !important;
	}

	/deep/ .el-submenu__title {
		border: none;
	}

	/deep/ .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
		color: #007FFF;
	}


	img {
		width: 100%;
		height: 100%;
	}


	/deep/ .el-menu--collapse .el-sub-menu__title span {
		display: none !important;
	}

	/deep/ .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
		display: none !important;
	}
</style>
